/* eslint-disable @typescript-eslint/no-unsafe-assignment,react-hooks/exhaustive-deps */
import React from 'react';
import { Typography, Form, Input, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { LOGIN } from 'src/graphql';
import { ADMIN, setToken } from 'src/services';
import { IAuth } from 'src/interfaces';
import { AuthImageHeader, PrimaryButton } from '../components';
import { Authentication } from '../interfaces/Authentication';

const { Title, Text } = Typography;
const { Password } = Input;
const FormItem = Form.Item;

type FormData = {
    email: string;
    password: string;
};

function Login({ setIsAuthenticated, setIsAdmin }: Authentication): React.ReactElement {
    const [loginMutation, { loading }] = useMutation(LOGIN);

    const handleLogin = (formData: FormData) => {
        const { email, password } = formData;
        loginMutation({
            variables: {
                credentials: {
                    email,
                    password,
                },
            },
        })
            .then((res) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                const token = res?.data?.login;
                setToken(token as IAuth);
                setIsAuthenticated(true);
                setIsAdmin((token as { user: { roleId: string } })?.user.roleId === ADMIN);
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="webkit-center">
            <AuthImageHeader topText="Account" pageTile="Login" breadCrumb="" />

            <Row justify="center" style={{ marginTop: '20px', marginBottom: "30px" }}>
                <Col
                    xs={{ span: 22 }}
                    sm={{ span: 20 }}
                    md={{ span: 18 }}
                    lg={{ span: 16 }}
                    xl={{ span: 10 }}
                    xxl={{ span: 10 }}
                >
                    <div className="auth-form" style={{ marginTop: '30px' }}>
                        <div style={{ marginBottom: '4px' }}>
                            <Text style={{ color: '#0C6A54', textAlign: 'left', fontWeight: 'bold' }}>
                                Please enter your email and password
                            </Text>
                        </div>
                        <Form className="" onFinish={handleLogin}>
                            <FormItem name="email" rules={[{ required: true, message: 'Email is required' }]}>
                                <Input
                                    placeholder="Email"
                                    type="email"
                                    style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                />
                            </FormItem>
                            <FormItem
                                name="password"
                                rules={[{ required: true, message: 'Password is required' }]}
                                style={{ marginBottom: '0px' }}
                            >
                                <Password
                                    placeholder="Password"
                                    style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px' }}
                                />
                            </FormItem>

                            <Row>
                                <Col span={12}>
                                    <Link to="/forgot-password">
                                        <Title level={5} className="auth-link" style={{ textAlign: 'left' }}>
                                            Forgot Password?
                                        </Title>
                                    </Link>
                                </Col>
                                
                          
                            </Row>

                            <div
                                style={{
                                    marginTop: '20px',
                                    width: '100%',
                                    textAlign: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    height: '50px',
                                    borderWidth: '2px',
                                    borderColor: '#0066ff',
                                }}
                            >
                                <PrimaryButton
                                    title="Login"
                                    htmlType="submit"
                                    loading={loading}
                                    styles={{
                                        backgroundColor: '#EE773B',
                                        borderRadius: '20px',
                                        textAlign: 'center',
                                        lineHeight: '25px',
                                        fontSize: '16px',
                                        height: '32px',
                                        width: '100px',
                                        padding: '0px',
                                    }}
                                />
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default Login;
